import { nodeArray } from 'meteora';
function each(selector, func) {
  var array = nodeArray(document.querySelectorAll(selector));
  if (func && typeof func === 'function') array.forEach(function (el, i) {
    return func(el, i);
  });
  return array;
}
export default each;